
<p-button icon="pi pi-times" class="close-button p-button" (click)="showOptions.set(false)"/>

<div class="flex flex-row ">
  <span class="flex align-items-center mr-2">Breite</span>
    <p-selectButton class="border-1 border-round "
      [options]="widthOptions"
      [(ngModel)]="data().columnSpan"
      (onChange)="dashboardService.updateWidget(data().widgetId, { columnSpan: +$event.value })"
      optionLabel="label"
      optionValue="value" />
</div>
<div class="flex flex-row mt-2">
  <span class="flex align-items-center mr-2">Höhe</span>
    <p-selectButton class="border-1 border-round "
      [options]="heightOptions"
      [(ngModel)]="data().rowSpan"
      (onChange)="dashboardService.updateWidget(data().widgetId, { rowSpan: +$event.value })"
      optionLabel="label"
      optionValue="value" />
</div>



<!--<p-button icon="pi pi-arrow-circle-right" class="move-forward-button p-button" (click)="dragAndDropService.moveWidgetToRight(data().widgetId)" />
<p-button icon="pi pi-arrow-circle-left" class="move-backward-button p-button" (click)="dragAndDropService.moveWidgetToLeft(data().widgetId)"/>-->

<p-button icon="pi pi-trash" class="remove-widget-button p-button"  (click)="dashboardService.removeWidget(data().widgetId)"/>
